import { useMemo } from "react";
import type { ExploreLocationState } from "@/hooks/useExploreLocation";

interface HeroTitleOptions {
  locationState: ExploreLocationState;
  boundsActive: boolean;
}

interface HeroTitle {
  title: string;
  subtitle: string;
}

/**
 * Dynamic hero title based on location state.
 * Priority: geo → city → boundsActive → default.
 * Pure derivation — no side effects, no re-render loops.
 */
export function useExploreHeroTitle({ locationState, boundsActive }: HeroTitleOptions): HeroTitle {
  return useMemo(() => {
    const subtitle = "Platser, gårdar och upplevelser värda att åka till.";

    if (locationState.type === "geo") {
      return { title: "Upptäck det som finns nära dig", subtitle };
    }
    if (locationState.type === "city") {
      return { title: `Upptäck det som finns i ${locationState.city}`, subtitle };
    }
    if (boundsActive) {
      return { title: "Detta finns i det här området", subtitle };
    }
    return { title: "Utforska Dalarna", subtitle };
  }, [locationState.type, locationState.type === "city" ? locationState.city : null, boundsActive]);
}
